import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

interface EmptyStateProps {
    icon?: React.ReactNode;
    message: string;
    actionLabel?: string;
    onAction?: () => void;
}

export function EmptyState({ icon, message, actionLabel, onAction }: EmptyStateProps) {
    return (
        <Box sx={{ py: 5, px: 2, textAlign: 'center', color: 'text.secondary', border: '1px dashed', borderColor: 'divider', borderRadius: 1 }}>
            {icon && <Box sx={{ mb: 1, '& svg': { fontSize: 36, color: 'text.disabled' } }}>{icon}</Box>}
            <Typography variant="body2">{message}</Typography>
            {actionLabel && onAction && (
                <Button size="small" startIcon={<AddIcon />} onClick={onAction} sx={{ mt: 1.5 }}>{actionLabel}</Button>
            )}
        </Box>
    );
}
